/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var MessageStatus;
(function (MessageStatus) {
    MessageStatus["Unresolved"] = "UNRESOLVED";
    MessageStatus["InReview"] = "IN_REVIEW";
    MessageStatus["Resolved"] = "RESOLVED";
})(MessageStatus || (MessageStatus = {}));
export function MessageStatusFromJSON(json) {
    return MessageStatusFromJSONTyped(json, false);
}
export function MessageStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function MessageStatusToJSON(value) {
    return value;
}
